import CryptoJS from "crypto-js";
import { isJSON } from "./index";
//加密
export function Encrypt(data) {
  //编码 key
  const key = CryptoJS.enc.Utf8.parse("huanbaoaes123321");
  //编码data
  data = CryptoJS.enc.Utf8.parse(data); // 加密模式为CBC，补码方式为NoPadding
  let encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  console.log("加密后的数据:", encrypted.toString()); //返回base64
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
//解密
export function Decrypt(data) {
  //编码
  const key = CryptoJS.enc.Utf8.parse("huanbaoaes123321"); //Base64编码
  console.log(data);

  const base64 = CryptoJS.enc.Base64.parse(data);
  const base64Str = CryptoJS.enc.Base64.stringify(base64);
  const decrypt = CryptoJS.AES.decrypt(base64Str, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  console.log("解密后的数据:", decryptedStr.toString());
  if (isJSON(decryptedStr)) {
    return JSON.parse(decryptedStr.toString());
  } else {
    return decryptedStr.toString();
  }
}
